import createFolderValidation from '@rd-web-markets/market/dist/folder_and_files/create_folder_validation';
export default prop => createFolderValidation(prop);